const CZ = {
  company: [
    "spolecnost s rucenim omezenym (s.r.o.)",
    "nadace",
    "ústav"
  ],
  legalArrangement: [
    "společnost komanditní (k.s.)",
    "družstvo",
    "spolek"
  ],
  soleProprietorship: [
    "živnost"
  ]
};
export {
  CZ as default
};
